export const getCurrentUrl = () => {
  return window.location.href;
};

// Solution for new environments: extracting dynamic environment name from the domain
export const getEnvironmentName = () => window.location.hostname.split('.')[1];
